<template>
    <div class="">
        <div class="mb-4">
            <span class="text-sm font-bold text-gray-500">03.</span>
        </div>
        <div class="mb-4">
            <span class="text-5xl font-extrabold tracking-tight">Vlakverdeling.</span>
        </div>
        <div class="mb-4">
            <span class="text-xl font-extrabold tracking-tight">Deur</span>
        </div>
        <div class="mb-4">
            <span class="font-extrabold tracking-tight">Liggers</span>
        </div>
        <div class="inline-flex mb-4">
            <button 
                class="px-4 py-2 mr-2 font-bold transition duration-500 ease-in-out border hover:bg-black hover:text-white"
                :class="doorBeamAmount === index ? ['bg-black', 'text-white'] : ['bg-gray-100', 'text-gray-500']"
                v-for="(doorBeamAmountButtons, index) in doorBeamAmountButtons"
                :key="doorBeamAmountButtons"
                @click="setDoorBeamAmount(index)"
            >
                {{ index }}
            </button>
        </div>
        <div class="mb-4">
            <span class="font-extrabold tracking-tight">Staanders</span>
        </div>
        <div class="inline-flex mb-4">
            <button 
                class="px-4 py-2 mr-2 font-bold transition duration-500 ease-in-out border hover:bg-black hover:text-white"
                :class="doorUprightAmount === index ? ['bg-black', 'text-white'] : ['bg-gray-100', 'text-gray-500']"
                v-for="(doorUprightAmountButtons, index) in doorUprightAmountButtons"
                :key="doorUprightAmountButtons"
                @click="setDoorUprightAmount(index)"
            >
                {{ index }}
            </button>
        </div>

        <div v-if="sidePanelAmount != 'none'">
            <div class="mb-4">
                <span class="text-xl font-extrabold tracking-tight">Zijpanelen</span>
            </div>
            <div class="mb-4">
                <span class="font-extrabold tracking-tight">Liggers</span>
            </div>
            <div class="inline-flex mb-4">
                <button
                    class="px-4 py-2 mr-2 font-bold transition duration-500 ease-in-out border hover:bg-black hover:text-white"
                    :class="sidePanelBeamAmount === index ? ['bg-black', 'text-white'] : ['bg-gray-100', 'text-gray-500']"
                    v-for="(sidePanelBeamAmountButtons, index) in sidePanelBeamAmountButtons"
                    :key="sidePanelBeamAmountButtons"
                    @click="setSidePanelBeamAmount(index)"
                >
                    {{ index }}
                </button>
            </div>
            <div class="mb-4">
                <span class="font-extrabold tracking-tight">Staanders</span>
            </div>
            <div class="inline-flex mb-4">
                <button
                    class="px-4 py-2 mr-2 font-bold transition duration-500 ease-in-out border hover:bg-black hover:text-white"
                    :class="sidePanelUprightAmount === index ? ['bg-black', 'text-white'] : ['bg-gray-100', 'text-gray-500']"
                    v-for="(sidePanelUprightAmountButtons, index) in sidePanelUprightAmountButtons"
                    :key="sidePanelUprightAmountButtons"
                    @click="setSidePanelUprightAmount(index)"
                >
                    {{ index }}
                </button>
            </div>
        </div>
        <div class="px-4 py-2 my-4 border">
            <p class="">Met je muiscursor of touch-screen kan je de vlakverdeling aanpassen door de liggers en staanders te slepen.</p>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { mapMutations } from 'vuex'

    export default {
        data() {
            return {
                doorBeamAmountButtons: 5,
                doorUprightAmountButtons: 5,
                sidePanelBeamAmountButtons: 5,
                sidePanelUprightAmountButtons: 5,
            }
        },
        methods: {
            ...mapMutations([
                'setDoorBeamAmount',
                'setDoorUprightAmount',
                'setSidePanelBeamAmount',
                'setSidePanelUprightAmount',
                'setDoorBeamPosition',
                'setDoorUprightPosition'
            ]),
        },
        computed: {
            ...mapState([
                'sidePanelAmount',
                'sidePanelDivision',
                'doorDivision',
                'doorAmount',
                'doorWidth',
                'doorHeight',
                'doorPixels',
                'doorBeamAmount',
                'doorUprightAmount',
                'sidePanelBeamAmount',
                'sidePanelUprightAmount'
            ]), 
        },
    }
    
</script>
    
<style>

</style>